import React from 'react'
import Layout from './Layout'
import Styles from './Styles'
import Customization from './Customization'
import OtherQuestions from './OtherQuestions'
const Faq = () => (
  <div>
    <Customization />
    <Layout />
    <Styles />
    <OtherQuestions />
  </div>
)
export default Faq
